import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Card, Col, Container, Form, Row, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import * as Yup from 'yup';
import Error from "../../../components/Error";
import { ContactForm } from "./styled";
import { useEffect, useState } from "react";
import { requestSupportContact } from "../../../services/profile.service";
import { toast } from "react-toastify";
import { ICommonTestComponent } from "../../../models/ICommonTestComponent";


const validationSchema = Yup.object({
    username: Yup.string().required("Este campo é obrigatório"),
    email: Yup.string().required("Este campo é obrigatório"),
    subject: Yup.string().required("Este campo é obrigatório"),
    message: Yup.string().required("Este campo é obrigatório"),
}).required();

export const SupportContact: React.FC<ICommonTestComponent> = ()  => {
    const { t: translation } = useTranslation();

    const { register, handleSubmit, formState: { errors } } = useForm({ resolver: yupResolver(validationSchema) });

    const queryParams = new URLSearchParams(window.location.search)
    const [subject, setSubject] = useState<any>();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (queryParams.get("subject")) {
            setSubject(queryParams.get("subject"));
        }
    }, [])

    const onSubmit = (params: any) => {
        setLoading(true)
        requestSupportContact(params).then((response: any) => {
            toast.success("Solicitação enviada com sucesso!");
            setLoading(false)
        }).catch((err) => {
            toast.error(err.response.data[0]);
            setLoading(false)
        })
    };

    return (
        <Container>
            <ContactForm>
                <Row className="justify-content-md-center">
                    <Col md={8} >
                        <Card className="mb-4 card-support-contact">
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                <Card.Header>
                                    <Card.Title>
                                        <Row>
                                            <Col xs={12} className="d-flex align-items-center">
                                                <h4 className="mb-0 p-3" style={{ fontSize: '22px' }}> {translation('contactForm.title')}</h4>
                                            </Col>
                                        </Row>
                                    </Card.Title>
                                </Card.Header>
                                <Card.Body>
                                    <Row className="px-3">
                                        <Col md={12}>
                                            <Row className="col-12">
                                                <Col xs={12} className="mb-2">
                                                    <Form.Group className="mb-2">
                                                        <Form.Label className="text-darker-grey"> {translation('contactForm.labelName')}:</Form.Label>
                                                        <Form.Control type="text" placeholder={translation('contactForm.labelName')}  {...register("username", { required: true })} />
                                                        {errors.username ? (<div className="w-100"> <Error>{errors.username?.message}</Error> </div>) : ""}
                                                    </Form.Group>
                                                </Col>

                                                <Col xs={12} className="mb-2">
                                                    <Form.Group className="mb-2">
                                                        <Form.Label className="text-darker-grey">{translation('contactForm.labelEmail')}:</Form.Label>
                                                        <Form.Control type="text" placeholder={translation('contactForm.labelEmail')}  {...register("email", { required: true })} />
                                                        {errors.email ? (<div className="w-100"> <Error>{errors.email?.message}</Error> </div>) : ""}
                                                    </Form.Group>
                                                </Col>

                                                <Col xs={12} className="mb-2">
                                                    <Form.Group className="mb-2">
                                                        <Form.Label className="text-darker-grey">{translation('contactForm.labelSubject')}:</Form.Label>
                                                        <Form.Select value={subject} placeholder={translation('contactForm.labelSubject')}  {...register("subject", { required: true })} >
                                                            <option value="Duvídas" >{translation('contactForm.subject.doubts')}</option>
                                                            <option value="Assinatura">{translation('contactForm.subject.subscription')}</option>
                                                            <option value="Renovação">{translation('contactForm.subject.renew')}</option>
                                                            <option value="Cancelar">{translation('contactForm.subject.cancel')}</option>
                                                        </Form.Select>
                                                        {errors.subject ? (<div className="w-100"> <Error>{errors.subject?.message}</Error> </div>) : ""}
                                                    </Form.Group>
                                                </Col>

                                                <Col xs={12} className="mb-2">
                                                    <Form.Group className="mb-2">
                                                        <Form.Label className="text-darker-grey">{translation('contactForm.labelMessage')}:</Form.Label>
                                                        <Form.Control as="textarea" rows={5} style={{ resize: 'none' }} placeholder={translation('contactForm.labelMessage')}  {...register("message", { required: true })} />
                                                        {errors.message ? (<div className="w-100"> <Error>{errors.message?.message}</Error> </div>) : ""}
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Card.Body>
                                <Card.Footer>
                                    <Row className="justify-content-end px-3 py-2">
                                        <Col xs={2}>
                                            {
                                                loading ? (
                                                    <Spinner animation="border" variant="primary" style={{ width: '2rem', height: '2rem', borderWidth: '0.25em', borderRightColor: 'transparent' }} />
                                                ) : (
                                                    <></>
                                                )
                                            }
                                            <Button variant="primary" className="btn-rounded" type="submit">{translation('contactForm.send')}</Button>
                                        </Col>
                                    </Row>
                                </Card.Footer>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </ContactForm >
        </Container >
    )
}